import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'topicNameByCode',
  standalone: true
})
export class TopicNameByCodePipe implements PipeTransform {
  public transform(v: string): string {
    switch (v) {
      case 'payment_terms': {
        return 'Chcę otrzymywać powiadomienia o terminach płatności (Podatki Opłaty za śmieci):';
      }
      case 'payment_status': {
        return 'Chcę otrzymywać powiadomienia o statusie płatności:';
      }
      case 'news': {
        return 'Chcę otrzymywać powiadomienia o aktualnościach:';
      }
      case 'event': {
        return 'Chcę otrzymywać powiadomienia o wydarzeniach:';
      }
      case 'rso': {
        return 'Chcę otrzymywać powiadomienia o ostrzeżeniach RSO:';
      }
      case 'civic_budget': {
        return 'Chcę otrzymywać powiadomienia o budżecie obywatelskim:';
      }
      case 'waste': {
        return 'Chcę otrzymywać powiadomienia o wywozie odpadów komunalnych:';
      }
      default: {
        return '';
      }
    }
  }
}
